export const API_GET_ALL_SYSTEM_LOG = "API_GET_ALL_SYSTEM_LOG"
